// @ts-nocheck
import * as React from "react";

const BoxCheckmarkFill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="m1 9.36 8.25 3.47V22h-.06L2 18.61a1.69 1.69 0 0 1-1-1.52V9.36Zm12.542 2.296A6.5 6.5 0 0 0 19 12.824V17.1a1.69 1.69 0 0 1-1 1.51L10.8 22h-.05v-9.17l2.792-1.174ZM17.503 1.35l.22.005a5.15 5.15 0 0 1 4.927 5.148l-.005.22a5.15 5.15 0 1 1-5.363-5.368l.221-.005ZM10.8 4.18l.538.252a6.498 6.498 0 0 0 1.04 6.07L10 11.5 1.49 7.93A1.62 1.62 0 0 1 2 7.55l7.2-3.37a1.87 1.87 0 0 1 1.6 0Zm6.7-1.53a3.85 3.85 0 0 0-.004 7.7l.196-.005a3.85 3.85 0 0 0 3.658-3.841l-.005-.196A3.85 3.85 0 0 0 17.5 2.65Zm2.141 1.83a.653.653 0 0 1 .123.916l-2.285 3a.655.655 0 0 1-.527.253l-.105-.01a.65.65 0 0 1-.395-.237l-1.223-1.566-.056-.087a.65.65 0 0 1 1.09-.7l.695.899 1.777-2.35.07-.08a.653.653 0 0 1 .836-.037Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(BoxCheckmarkFill);
